'use strict';

/**
 * Two-segment ("knee") scale for a slider: the first part of the track covers the small
 * values with more room, the rest covers the large values more steeply.
 *
 * Example for the loan amount: 2 000–20 000 € takes the first third of the track,
 * 20 000–250 000 € the remaining two thirds. Positions are integers 0..POSITIONS so a
 * native <input type="range"> can drive the mapping; the value is always snapped to `step`.
 */

export const POSITIONS = 6000;

export function makeKneeScale({ min, max, step, knee, kneeAt }) {
  const clamp = (n) => Math.min(max, Math.max(min, n));
  const snap = (n) => clamp(Math.round(n / step) * step);
  const kneePos = kneeAt * POSITIONS;

  const toPosition = (value) => {
    const v = clamp(value);
    if (v <= knee) return Math.round(((v - min) / (knee - min)) * kneePos);
    return Math.round(kneePos + ((v - knee) / (max - knee)) * (POSITIONS - kneePos));
  };

  const toValue = (position) => {
    const p = Math.min(POSITIONS, Math.max(0, position));
    if (p <= kneePos) return snap(min + (p / kneePos) * (knee - min));
    return snap(knee + ((p - kneePos) / (POSITIONS - kneePos)) * (max - knee));
  };

  return { toPosition, toValue, snap, clamp, positions: POSITIONS };
}
